/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { OrganisationSettingViewOrganisationSetting } from './organisationSettingViewOrganisationSetting';

export interface OrganisationSettingsView { 
    /**
     * The unique identifier of this record.
     */
    defaultSettingId?: number;
    name?: string;
    description?: string;
    defaultValue?: string;
    groupName?: string;
    type?: OrganisationSettingsView.TypeEnum;
    granularity?: OrganisationSettingsView.GranularityEnum;
    displayInUi?: boolean;
    isEditable?: boolean;
    organisationSetting?: Array<OrganisationSettingViewOrganisationSetting>;
}
export namespace OrganisationSettingsView {
    export type TypeEnum = 'string' | 'integer' | 'boolean' | 'number' | 'timestamp';
    export const TypeEnum = {
        String: 'string' as TypeEnum,
        Integer: 'integer' as TypeEnum,
        Boolean: 'boolean' as TypeEnum,
        Number: 'number' as TypeEnum,
        Timestamp: 'timestamp' as TypeEnum
    };
    export type GranularityEnum = 'organisation' | 'venue';
    export const GranularityEnum = {
        Organisation: 'organisation' as GranularityEnum,
        Venue: 'venue' as GranularityEnum
    };
}